import React, { useState, useRef } from "react";
import "./collapsible.css";
import { VscSettings } from "react-icons/vsc";
import { GiSettingsKnobs } from "react-icons/gi";
import { Tooltip } from "antd";
import { MdOutlineDateRange } from "react-icons/md";
import PartyIcon from "./PartyIcon";
const TopFilterBarPotrait = ({
  locationField,
  dateRangeField,
  partyField,
  searchBar,
  startDate,
  endDate,
  partyText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  const collapsibleRef = useRef(null);

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          height: isOpen ? "10rem" : "5rem",
          transition: "height 0.4s ease",
        }}
      ></div>
      <div className="collapsible" ref={collapsibleRef}>
        <button className="collapsible-toggle">
          <div
            style={{
              width: "1.5rem",
              height: "1.5rem",
              minWidth: "1.5rem",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flex: 1,
            }}
          >
            <div              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "white",
                borderRadius: "0.4rem",
                border: "1px solid #d9d9d9",
              }}
            >
              <div
                style={{
                  width: "100%",
                }}
              >
                {locationField}
              </div>
              {!isOpen && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    color: "grey",
                    // padding: "0 0 0.5rem 1rem",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    fontSize: "0.8rem",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    padding: 0,
                    paddingBottom: "0.8rem",
                    paddingTop: "0.8rem",
                  }}
                  onClick={toggleCollapsible}
                >
                  <div
                    style={{
                      width: "0.5rem",
                      height: "0.5rem",
                      minWidth: "0.5rem",
                    }}
                  ></div>
                  <div
                    style={{
                      height: "1rem",
                      width: "1rem",
                      minWidth: "1rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "black",
                    }}
                  >
                    <Tooltip
                      title="Filter by dates and party size"
                      style={{
                        width: "100%",
                        backgroundColor: "transparent",
                        padding: 0,
                        border: "none",
                        margin: 0,
                        color: "black",
                      }}
                    >
                      <MdOutlineDateRange size={"1rem"} />
                      
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      width: "0.5rem",
                      height: "0.5rem",
                      minWidth: "0.5rem",
                    }}
                  ></div>
                  <div style={{ marginBottom: "-0.1rem" }}>
                    <Tooltip
                      title="Filter by start and end dates"
                      style={{
                        width: "100%",
                        backgroundColor: "transparent",
                        padding: 0,
                        border: "none",
                        margin: 0,
                        color: "black",
                      }}
                    >
                      <div style={{color: "black"}}>{startDate.replace(/-/g, "/")} -{" "}
                      {endDate.replace(/-/g, "/")}</div>
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      width: "0.5rem",
                      height: "0.5rem",
                      minWidth: "0.5rem",
                    }}
                  ></div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "black",
                      height: "1rem",
                      width: "1rem",
                    }}
                  >
                    
                  <PartyIcon partyType={partyText} size={"1rem"} />  
                  </div>
                  <div
                    style={{
                      width: "0.5rem",
                      height: "0.5rem",
                      minWidth: "0.5rem",
                    }}
                  ></div>
                  <Tooltip
                    title="Filter by party type"
                    style={{
                      width: "100%",
                      backgroundColor: "transparent",
                      padding: 0,
                      border: "none",
                      margin: 0,
                      color: "black",
                    }}
                  >
                    <div style={{color: "black"}}>{partyText}</div>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              width: "1.5rem",
              height: "1.5rem",
              minWidth: "1.5rem",
            }}
          ></div>
        </button>
        <div
          className="collapsible-content"
          style={{
            maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : "0",
          }}
        >
          <div
            style={{
              width: "1.5rem",
              height: "1.5rem",
              minWidth: "1.5rem",
            }}
          ></div>
          <div
            // className="collapsible-content"
            ref={contentRef}
            style={{
              flex: 1,
              margin: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "0.5rem",
                height: "0.5rem",
                minHeight: "0.5rem",
              }}
            ></div>

           
              <div style={{ width: "100%" }}>
              <Tooltip
              title="Travel Dates"
              style={{
                width: "100%",
                backgroundColor: "transparent",
                padding: 0,
                border: "none",
                margin: 0,
              }}
            >
              {" "}{dateRangeField}
              </Tooltip></div>
          
            <div
              style={{
                
                width: "0.5rem",
                height: "0.5rem",
                minHeight: "0.5rem",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: "0.5rem",
              }}
            >
              
                <div style={{ width: "100%" }}>
                <Tooltip
                title="Party Details"
                style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  padding: 0,
                  border: "none",
                  margin: 0,
                }}
              >
                {" "}{partyField}
              </Tooltip>
              </div>
              <div onClick={toggleCollapsible}>{searchBar}</div>
            </div>
          </div>
          <div
            style={{
              width: "1.5rem",
              height: "1.5rem",
              minWidth: "1.5rem",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TopFilterBarPotrait;
